// const orderLayout = resolve => require(['./toursOrder/layout.vue'], resolve);
// const dashboard = resolve => require(['../dashboard.vue'], resolve);
export default [{
    name: 'dashboard',
    children: [{
            path: '/statistics/statistical',
            name: 'statistical',
            component: resolve => require(['./statistical.vue'], resolve)
        },
        // {
        //     name:'clientStatistics',
        //     path: '/statistics/clientStatistics',
        //     component: resolve => require(['./clientStatistics.vue'], resolve)
        // }
    ]
}]



// WEBPACK FOOTER //
// ./src/views/statistics/router.js